'use strict';

var _ = require('lodash');

/**
 * Market Analysis - Service tab - Grid
 */
var ServiceClassGridTransformerFactory = function ServiceClassGridTransformerFactory($filter, DataTransformer, bookingsIntakeTransformationService, mergeScenarioDataService, effectiveValueService, configurationService, renormalizeEffectiveValueService, momentService, hepService, featureToggleService, classIndicesService, marketLiveDataService, fcrService, bookingsTrendCorrectionTransformationService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function getTimeOfDaySize() {
    return configurationService.getTimeOfDayBucketSize();
  }
  function getTimeOfDayOfMoment(moment) {
    moment = moment.clone();
    var bucket = moment.hours() - moment.hours() % getTimeOfDaySize();
    return [moment.hours(bucket).minutes(0).format('HH:mm'), moment.hours(Math.min(24, bucket + getTimeOfDaySize())).minutes(0).subtract(1, 'minutes').format('HH:mm')].join('-');
  }
  function getTimeOfMoment(moment) {
    return momentService.copy(moment.clone(), momentService.TYPE.LOCAL_TIME);
  }
  function setLastRefreshTime(timeStamp) {
    if (timeStamp) {
      marketLiveDataService.setLastRefreshTime('service-demand-analysis', momentService.of(timeStamp, momentService.FIELD.EVENT_TIME_STAMP));
    }
  }
  function ServiceClassGridTransformer() {
    this.sourceType = 'service';
    this.targetType = ['service-demand-analysis', 'service-demand-analysis-data-handler'];
    this.priority = 1;
  }
  ServiceClassGridTransformer.prototype = Object.create(DataTransformer.prototype);
  ServiceClassGridTransformer.constructor = ServiceClassGridTransformer;
  ServiceClassGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType.indexOf(targetType) !== -1;
  };
  ServiceClassGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  ServiceClassGridTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType.join('-') + '-' + metrics.join('-');
  };
  ServiceClassGridTransformer.prototype.transform = function (data) {
    setLastRefreshTime(data.domain.timeStamp);
    var memoizedClassGroupIndices = _.memoize(classIndicesService.prepareClassGroupIndices);
    var memoizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memoizedMomentOfEventDate = _.memoize(getMomentOfDate);
    var memoizedDOWOfMoment = _.memoize(getDOWOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedYearMonthDayOfMoment = _.memoize(getYearMonthDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedTimeOfDayOfMoment = _.memoize(getTimeOfDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedGetTimeOfMoment = _.memoize(getTimeOfMoment, function (moment) {
      return moment.valueOf();
    });
    var alertThreshold = hepService.getSimpleHepProperties().ALERT_THRESHOLD;
    var isDemandDistributionIncremental = configurationService.isDemandDistributionIncremental();
    function setEffectiveValues(result, entry) {
      if (!isDemandDistributionIncremental) {
        var effective = effectiveValueService.calculateAll(entry, 'service-demand-analysis');
        _.assign(result, effective);
      } else {
        result.effectiveRegularRemainingDemandFC = entry.regularRemainingDemandAdjustedFC === undefined ? entry.regularRemainingDemandFC : entry.regularRemainingDemandAdjustedFC;
        result.effectiveMappedRemainingDemandFC = entry.mappedRemainingDemandAdjustedFC === undefined ? entry.mappedRemainingDemandFC : entry.mappedRemainingDemandAdjustedFC;
        result.effectiveRegularAggregateShare = entry.regularEffShare;
        result.effectiveMappedAggregateShare = entry.mappedEffShare;
      }
    }
    var isMappedMode = featureToggleService.isEnabled('MAPPED_MODE');
    var transformData = function transformData(serviceClasses) {
      var result = [];
      if (!serviceClasses || !serviceClasses.length) {
        return;
      }
      for (var i = 0, length = serviceClasses.length; i < length; i++) {
        var entry = serviceClasses[i];
        var entryKey = entry.serviceId + entry.carrier + entry.market + entry.significantPOS + entry.classGroup + entry.className + entry.departureDate;
        var momentDepartureDate = memoizedMomentOfDepartureDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
        var momentEventTimeStamp = memoizedMomentOfEventDate(entry.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        var curDOW = memoizedDOWOfMoment(momentDepartureDate);
        var curYMD = memoizedYearMonthDayOfMoment(momentDepartureDate);
        var isManuallyControlled = _.isNil(entry.userRegularIsManuallyControlled) ? entry.isManuallyControlled ? 'Yes' : 'No' : entry.userRegularIsManuallyControlled === 'true' ? 'Yes' : 'No';
        var newEntry = {
          entryKey: entryKey,
          scenarioName: entry.scenarioName,
          carrier: entry.carrier,
          hostCarrier: configurationService.getHostCarrier(),
          market: entry.market,
          origin: entry.origin,
          destination: entry.destination,
          route: entry.route,
          posName: entry.significantPOS,
          //added for POS
          numberOfStops: entry.numberOfStops,
          //added for numberOfStops
          season: entry.season,
          dowGroup: entry.dowGroup,
          serviceBusinessId: entry.serviceBusinessId,
          regularProfileLevel: entry.regularProfileLevel,
          mappedProfileLevel: entry.mappedProfileLevel,
          classGroup: entry.classGroup,
          classGroupIndex: memoizedClassGroupIndices(fcrService.getClassGroupIndicesKey(momentDepartureDate, entry.market))[entry.classGroup],
          className: entry.className,
          relativeValue: entry.relativeValue,
          significantPOS: entry.significantPOS,
          elapsedTime: entry.elapsedTime,
          criticality: entry.criticality,
          serviceId: entry.serviceId,
          referenceCurveServiceId: entry.referenceCurveServiceId,
          serviceClassId: entry.serviceClassId,
          mappedTripBooking: entry.mappedTripBookings,
          regularTripBooking: entry.regularTripBookings,
          fare: entry.fare,
          proratedFare: entry.proratedFare,
          mappedFare: entry.mappedFare,
          mappedProratedFare: entry.mappedProratedFare,
          mappedReservationHoldingsTotal: entry.mappedReservationHoldingsTotal,
          mappedReservationHoldingsIdv: entry.mappedReservationHoldingsIdv,
          mappedReservationHoldingsGroup: entry.mappedReservationHoldingsGroup,
          mappedExpectedBookings: entry.mappedExpectedBookings,
          mappedRevenueTotal: entry.mappedRevenueTotal,
          mappedRevenueExpectedTotal: entry.mappedRevenueExpectedTotal,
          mappedRemainingDemandFC: entry.mappedRemainingDemandFC,
          calculatedMappedRemainingDemandFC: entry.calculatedMappedRemainingDemandFC,
          baseMappedRemainingDemandFC: entry.effectiveMappedBaseRemainingDemandFC,
          userTypeMappedRemainingDemandFC: entry.userTypeMappedRemainingDemandFC,
          userValueMappedRemainingDemandFC: entry.userValueMappedRemainingDemandFC,
          effectiveMappedRemainingDemandFC: entry.effectiveMappedRemainingDemandFC,
          mappedRemainingDemandFCCV: entry.mappedRemainingDemandFCCV,
          mappedRemainingDemandMWTP: entry.mappedRemainingDemandMWTP,
          mappedRemainingDemandMWTPCV: entry.mappedRemainingDemandMWTPCV,
          mappedRemainingDemandPreBTC: entry.mappedRemainingDemandPreBTC,
          mappedSellupRate: entry.mappedSellupRate,
          mappedLastYearCurrentBookings: entry.mappedLastYearCurrentBookings,
          mappedLastYearFinalBookings: entry.mappedLastYearFinalBookings,
          mappedLastYearCurrentRevenue: entry.mappedLastYearCurrentRevenue,
          mappedLastYearFinalRevenue: entry.mappedLastYearFinalRevenue,
          availability: entry.currentAvailability,
          mappedAvailability: entry.mappedCurrentAvailability,
          bidPrice: entry.bidPrice,
          details: entry.details,
          mappedAggregateShare: entry.mappedAggregateShare,
          userMappedAggregateShare: entry.userMappedAggregateShare,
          effectiveMappedAggregateShare: entry.effectiveMappedAggregateShare,
          daysToDeparture: entry.daysToDeparture,
          startRtpRegularRemainingDemandFC: _.isNil(entry.startRtpRegularRemainingDemandFC) ? entry.daysToDeparture : entry.startRtpRegularRemainingDemandFC,
          startRtpMappedRemainingDemandFC: _.isNil(entry.startRtpMappedRemainingDemandFC) ? entry.daysToDeparture : entry.startRtpMappedRemainingDemandFC,
          departureDate: curYMD,
          departureDateMoment: momentDepartureDate,
          departureTimeMoment: memoizedGetTimeOfMoment(momentDepartureDate),
          departureDateMomentTimeOfDay: memoizedTimeOfDayOfMoment(momentDepartureDate.value),
          departureDateMomentDDD: curDOW,
          lastProcessedDateMoment: momentEventTimeStamp,
          appliedRules: entry.appliedRules,
          markRenormalize: undefined,
          associatedLegCabins: entry.associatedLegCabins,
          isForecastIgnored: entry.isForecastIgnored,
          isDiscontinued: entry.isDiscontinued ? 'Yes' : 'No',
          isManuallyControlled: isManuallyControlled,
          alerts: entry.alertScore,
          numberOfAlertRulesApplied: entry.numberOfAlertRulesApplied,
          alertThresholdExceeded: entry.alertScore > alertThreshold,
          eventTimeStamp: entry.eventTimeStamp,
          latestChanges: entry.latestChanges,
          appliedRulesNumber: entry.appliedRules.length,
          liveAvailability: entry.liveAvailability,
          liveTotalBkgs: entry.invResHoldTotal,
          liveIdvBkgs: entry.invResHoldIdv,
          liveGrpBkgs: entry.invResHoldGroup,
          mappedLiveAvailability: entry.mappedLiveAvailability,
          mappedLiveTotalBkgs: entry.mappedInvResHoldTotal,
          mappedLiveIdvBkgs: entry.mappedInvResHoldIdv,
          mappedLiveGrpBkgs: entry.mappedInvResHoldGroup,
          serviceClassAuthorizationModel: entry.authorizationModel,
          userRegularMinAuthorization: entry.userRegularHardOverrideType === 'AUTH' ? entry.userRegularHardOverrideMinValue : null,
          userRegularMaxAuthorization: entry.userRegularHardOverrideType === 'AUTH' ? entry.userRegularHardOverrideMaxValue : null,
          userRegularAuthLink: entry.userRegularLinkType === 'AUTH' ? entry.userRegularLinkValue : null,
          serviceClassAuthorizationAfterRules: entry.authorizationAfterRules,
          serviceClassSeatsAvailModel: entry.seatsAvailModel,
          userRegularMinAvailability: entry.userRegularHardOverrideType === 'AVAIL' ? entry.userRegularHardOverrideMinValue : null,
          userRegularMaxAvailability: entry.userRegularHardOverrideType === 'AVAIL' ? entry.userRegularHardOverrideMaxValue : null,
          userRegularAvailLink: entry.userRegularLinkType === 'AVAIL' ? entry.userRegularLinkValue : null,
          serviceClassSeatsAvailabilityAfterRules: entry.seatsAvailabilityAfterRules,
          regularIsBookingTrendCorrectionRequired: entry.regularIsBookingTrendCorrectionRequired,
          regularBookingTrendCorrectionFactor: entry.regularBookingTrendCorrectionFactor,
          mappedIsBookingTrendCorrectionRequired: entry.mappedIsBookingTrendCorrectionRequired,
          mappedBookingTrendCorrectionFactor: entry.mappedBookingTrendCorrectionFactor
        };
        if (isMappedMode) {
          _.assign(newEntry, {
            regularReservationHoldingsTotal: entry.regularReservationHoldingsTotal,
            regularReservationHoldingsIdv: entry.regularReservationHoldingsIdv,
            regularReservationHoldingsGroup: entry.regularReservationHoldingsGroup,
            regularExpectedBookings: entry.regularExpectedBookings,
            regularRevenueTotal: entry.regularRevenueTotal,
            regularRevenueExpectedTotal: entry.regularRevenueExpectedTotal,
            regularRemainingDemandFC: entry.regularRemainingDemandFC,
            calculatedRegularRemainingDemandFC: entry.calculatedRegularRemainingDemandFC,
            baseRegularRemainingDemandFC: entry.effectiveRegularBaseRemainingDemandFC,
            userTypeRegularRemainingDemandFC: entry.userTypeRegularRemainingDemandFC,
            userValueRegularRemainingDemandFC: entry.userValueRegularRemainingDemandFC,
            effectiveRegularRemainingDemandFC: entry.effectiveRegularRemainingDemandFC,
            regularRemainingDemandFCCV: entry.regularRemainingDemandFCCV,
            regularRemainingDemandMWTP: entry.regularRemainingDemandMWTP,
            regularRemainingDemandMWTPCV: entry.regularRemainingDemandMWTPCV,
            regularRemainingDemandPreBTC: entry.regularRemainingDemandPreBTC,
            regularSellupRate: entry.regularSellupRate,
            regularAggregateShare: entry.regularAggregateShare,
            userRegularAggregateShare: entry.userRegularAggregateShare,
            effectiveRegularAggregateShare: entry.effectiveRegularAggregateShare,
            regularLastYearCurrentBookings: entry.regularLastYearCurrentBookings,
            regularLastYearFinalBookings: entry.regularLastYearFinalBookings,
            regularLastYearCurrentRevenue: entry.regularLastYearCurrentRevenue,
            regularLastYearFinalRevenue: entry.regularLastYearFinalRevenue
          });
        }
        bookingsIntakeTransformationService.calculateBookingsIntake(newEntry, entry);
        effectiveValueService.setDefaultTypes(newEntry);
        setEffectiveValues(newEntry, entry);
        result.push(newEntry);
      }
      return result;
    };
    return _.chain(data.domain.serviceClassPOS).thru(function (serviceClassPOS) {
      // Initial Transformation
      return transformData(serviceClassPOS);
    }).thru(function (transformedData) {
      // Merge Scenario Data Stage
      var domain = data.thirdDomain || data.secondDomain;
      var scenarioData = transformData(domain && domain.serviceClassPOS || []);
      return mergeScenarioDataService.merge(transformedData, scenarioData);
    }).thru(function (unNormalizedData) {
      // Normalization Data Stage
      if (renormalizeEffectiveValueService.shouldApplyRenormalization(unNormalizedData)) {
        return renormalizeEffectiveValueService.renormalizeAll(unNormalizedData);
      }
      return unNormalizedData;
    }).thru(function (normalizedData) {
      // Bookings Trend Correction
      return bookingsTrendCorrectionTransformationService.applyBTCFactor(normalizedData);
    }).value();
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  function getDOWOfMoment(moment) {
    return rmMomentFormat(moment, 'DAY_OF_WEEK');
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE_ISO');
  }
  return ServiceClassGridTransformer;
};
ServiceClassGridTransformerFactory.$inject = ['$filter', 'DataTransformerFactory', 'BookingsIntakeTransformationService', 'MergeScenarioDataService', 'CalculateEffectiveValueService', 'ConfigurationService', 'RenormalizeEffectiveValueService', 'MomentService', 'HepService', 'FeatureToggleService', 'ClassIndicesService', 'MarketLiveDataService', 'FcrService', 'BookingsTrendCorrectionTransformationService'];
module.exports = ServiceClassGridTransformerFactory;